import React, { useState, useEffect } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import PayrocCreditCardPaymentForm from '../PayrocCreditCardPaymentForm';

const PaymentFormPlaceholder = () => (
    <div
        style={{
            width: '100%',
            minHeight: '475px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
        }}
    >
        <Spinner
            animation="border"
            role="status"
            variant="secondary"
            style={{
                width: '3rem',
                height: '3rem',
            }}
        />
        <div style={{ color: '#6c757d', fontSize: '0.9rem' }}>Loading secure payment form...</div>
    </div>
);

const PayrocPaymentModal = React.memo(({ show, onHide, tripSetting, handleSubmitPayment, companyId }) => {
    const [creditCardSessionTimer, setCreditCardSessionTimer] = useState(null);
    const [isFormLoaded, setIsFormLoaded] = useState(false);
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        let interval;
        if (show && creditCardSessionTimer) {
            interval = setInterval(() => {
                setCreditCardSessionTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [show, creditCardSessionTimer]);

    useEffect(() => {
        let timeout;
        if (isFormLoaded) {
            timeout = setTimeout(() => {
                setShowForm(true);
            }, 1000);
        }
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [isFormLoaded]);

    const handleClose = () => {
        setCreditCardSessionTimer(null);
        setIsFormLoaded(false);
        setShowForm(false);
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="md"
            aria-labelledby="payment-modal"
            centered
            dialogClassName="payroc-payment-modal"
            style={{ minHeight: '550px' }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header
                closeButton
                style={{
                    backgroundColor: tripSetting.sectionColor,
                    color: tripSetting.textColor,
                    padding: '12px 24px',
                }}
            >
                <Modal.Title id="payment-modal">Card Information</Modal.Title>
            </Modal.Header>
            <Modal.Body
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    height: '475px',
                }}
            >
                <div
                    style={{
                        padding: '8px 0px',
                        marginBottom: '16px',
                        backgroundColor: '#fff3cd',
                        border: '1px solid #ffeeba',
                        borderRadius: '4px',
                        color: '#856404',
                        fontSize: '0.9rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: '40px',
                        maxWidth: '435px',
                    }}
                >
                    {creditCardSessionTimer > 0 && (
                        <>
                            <i className="fas fa-clock mr-2"></i>
                            Session expires in: {Math.floor(creditCardSessionTimer / 60)}:
                            {(creditCardSessionTimer % 60).toString().padStart(2, '0')}
                        </>
                    )}
                </div>
                <div
                    style={{
                        position: 'relative',
                        minHeight: '475px',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {!showForm && <PaymentFormPlaceholder />}
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            opacity: showForm ? 1 : 0,
                            visibility: showForm ? 'visible' : 'hidden',
                            transition: 'opacity 0.5s ease-in-out, visibility 0.5s ease-in-out',
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <PayrocCreditCardPaymentForm
                            setCreditCardSessionTimer={(timer) => {
                                setCreditCardSessionTimer(timer);
                                setIsFormLoaded(true);
                            }}
                            handleSubmit={(e, token) => {
                                handleSubmitPayment(e, token);
                                handleClose();
                            }}
                            companyID={companyId}
                            tripSetting={tripSetting}
                        />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
});

export default PayrocPaymentModal;
